document.addEventListener('DOMContentLoaded', () => {
    // Initialize Supabase with configuration from config.js
    const config = window.appConfig || {};
    const supabaseUrl = config.supabaseUrl;
    const supabaseAnonKey = config.supabaseAnonKey;
    
    if (!supabaseUrl || !supabaseAnonKey) {
        console.error('Supabase configuration is missing. Please check your environment variables.');
        alert('Terjadi kesalahan konfigurasi. Silakan hubungi administrator.');
        return;
    }
    
    const supabase = window.supabase.createClient(supabaseUrl, supabaseAnonKey);

    const questionsData = [
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '1. Guru menyampaikan materi pelajaran dengan cara yang mudah dipahami oleh anak saya.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '2. Guru menggunakan contoh atau media yang relevan sehingga pelajaran lebih menarik.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '3. Guru mampu menciptakan suasana belajar di kelas yang aktif dan menyenangkan.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '4. Guru mendorong anak saya untuk berani bertanya dan berpendapat di kelas.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '5. Tugas atau pekerjaan rumah yang diberikan guru sesuai dengan materi yang diajarkan.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '6. Penilaian (ulangan/tugas) yang diberikan guru terasa adil dan objektif.' },
        { category: 'A. KEMAMPUAN MENGAJAR (PEDAGOGIK)', text: '7. Guru mampu mengelola kondisi kelas dengan baik sehingga proses belajar berjalan lancar.' },
        { category: 'B. SIKAP DAN INTERAKSI DENGAN SISWA (KEPRIBADIAN & SOSIAL)', text: '8. Guru menunjukkan perhatian terhadap perkembangan personal (bukan hanya akademik) anak saya.' },
        { category: 'B. SIKAP DAN INTERAKSI DENGAN SISWA (KEPRIBADIAN & SOSIAL)', text: '9. Guru peduli dan memberikan bimbingan jika anak saya menghadapi kesulitan.' },
        { category: 'B. SIKAP DAN INTERAKSI DENGAN SISWA (KEPRIBADIAN & SOSIAL)', text: '10. Guru mampu menjadi teladan yang baik bagi para siswa.' },
        { category: 'B. SIKAP DAN INTERAKSI DENGAN SISWA (KEPRIBADIAN & SOSIAL)', text: '11. Anak saya merasa nyaman dan termotivasi untuk belajar dengan guru tersebut.' },
        { category: 'B. SIKAP DAN INTERAKSI DENGAN SISWA (KEPRIBADIAN & SOSIAL)', text: '12. Guru memperlakukan semua siswa di kelas secara adil dan tidak membeda-bedakan.' },
        { category: 'C. KOMUNIKASI DENGAN ORANG TUA', text: '13. Guru memberikan informasi yang jelas mengenai kemajuan belajar anak saya.' },
        { category: 'C. KOMUNIKASI DENGAN ORANG TUA', text: '14. Guru secara proaktif menginformasikan jika ada hal-hal penting terkait anak saya di sekolah.' },
        { category: 'C. KOMUNIKASI DENGAN ORANG TUA', text: '15. Bahasa yang digunakan guru saat berkomunikasi dengan saya mudah dimengerti dan sopan.' },
        { category: 'C. KOMUNIKASI DENGAN ORANG TUA', text: '16. Guru mudah dihubungi dan bersedia meluangkan waktu untuk berdiskusi.' },
        { category: 'C. KOMUNIKASI DENGAN ORANG TUA', text: '17. Guru memberikan respon yang cepat dan solutif ketika saya mengajukan pertanyaan atau masalah.' },
        { category: 'D. PROFESIONALISME GURU', text: '18. Guru menunjukkan kedisiplinan (misalnya, masuk kelas tepat waktu).' },
        { category: 'D. PROFESIONALISME GURU', text: '19. Guru menunjukkan sikap yang profesional dan ramah dalam berinteraksi.' },
        { category: 'D. PROFESIONALISME GURU', text: '20. Guru terbuka dan dapat menerima masukan atau saran dari orang tua murid.' },
        { category: 'E. KEBERSIHAN DAN SARANA KELAS', text: '21. Ruang kelas anak saya (lantai, dinding, jendela) terjaga kebersihan dan kerapiannya.' },
        { category: 'E. KEBERSIHAN DAN SARANA KELAS', text: '22. Meja dan kursi yang digunakan anak saya dalam kondisi baik, bersih, dan aman.' },
        { category: 'E. KEBERSIHAN DAN SARANA KELAS', text: '23. Penerangan (lampu) dan sirkulasi udara (jendela/ventilasi) di dalam kelas sangat memadai.' },
        { category: 'E. KEBERSIHAN DAN SARANA KELAS', text: '24. Sekolah menyediakan fasilitas kebersihan dasar seperti tempat sampah yang layak di dalam atau dekat kelas.' },
        { category: 'E. KEBERSIHAN DAN SARANA KELAS', text: '25. Saya yakin bahwa kondisi fasilitas di dalam kelas (misalnya stop kontak, jendela) aman untuk anak saya.' },
    ];

    // DOM Elements
    const form = document.getElementById('satisfactionForm');
    const welcomePage = document.getElementById('welcome-page');
    const respondentDataPage = document.getElementById('respondent-data-page');
    const instructionsPage = document.getElementById('instructions-page');
    const progressSection = document.getElementById('progress-section');
    const currentCategoryTitleDiv = document.getElementById('current-category-title');
    const currentCategoryTitleH3 = currentCategoryTitleDiv.querySelector('h3');
    const questionPagesContainer = document.getElementById('question-pages-container');
    const finalPage = document.getElementById('final-page');
    const thankYouMessage = document.getElementById('thankYouMessage');
    
    const startSurveyButton = document.getElementById('startSurveyButton');
    const prevButton = document.getElementById('prevButton');
    const nextButton = document.getElementById('nextButton');
    const submitButton = document.getElementById('submitButton');
    
    const progressBarFill = document.getElementById('progressFill');
    const progressText = document.getElementById('progressText');

    const options = [
        { label: 'Sangat Baik', value: 4 },
        { label: 'Baik', value: 3 },
        { label: 'Cukup', value: 2 },
        { label: 'Kurang', value: 1 }
    ];

    let currentStepIndex = 0; // 0: Welcome, 1: Respondent Data, 2: Instructions, 3+: Questions, Last: Final
    const totalQuestions = questionsData.length;
    const totalSteps = 3 + totalQuestions + 1; // Welcome + Data + Instructions + Questions + Final

    // Create a single question page
    function createQuestionPage(q, globalIndex) {
        const pageDiv = document.createElement('div');
        pageDiv.classList.add('question-page');
        pageDiv.id = `question-page-${globalIndex}`;

        const questionText = document.createElement('p');
        questionText.textContent = q.text;
        pageDiv.appendChild(questionText);

        const optionsGroup = document.createElement('div');
        optionsGroup.classList.add('options-group');

        options.forEach(opt => {
            const radioInput = document.createElement('input');
            radioInput.type = 'radio';
            radioInput.id = `q${globalIndex}-${opt.label}`;
            radioInput.name = `q${globalIndex}`;
            radioInput.value = opt.value;
            
            const radioLabel = document.createElement('label');
            radioLabel.htmlFor = `q${globalIndex}-${opt.label}`;
            radioLabel.textContent = opt.label;
            
            optionsGroup.appendChild(radioInput);
            optionsGroup.appendChild(radioLabel);

            radioInput.addEventListener('change', updateProgressBar);
        });

        pageDiv.appendChild(optionsGroup);
        return pageDiv;
    }

    // Initialize all question pages
    function initializeQuestionPages() {
        questionsData.forEach((q, index) => {
            const questionPage = createQuestionPage(q, index + 1); // 1-based global index
            questionPagesContainer.appendChild(questionPage);
        });
    }

    // Show a specific step
    function showStep(stepIndex) {
        // Hide all steps and question pages
        document.querySelectorAll('.survey-step').forEach(step => {
            step.classList.remove('active');
        });
        document.querySelectorAll('.question-page').forEach(page => {
            page.classList.remove('active');
        });
        finalPage.classList.remove('active');
        progressSection.classList.add('hidden');
        currentCategoryTitleDiv.classList.add('hidden');

        currentStepIndex = stepIndex;

        switch (stepIndex) {
            case 0: // Welcome Page
                welcomePage.classList.add('active');
                break;
            case 1: // Respondent Data Page
                respondentDataPage.classList.add('active');
                break;
            case 2: // Instructions Page
                instructionsPage.classList.add('active');
                break;
            case totalSteps - 1: // Final Page (last step)
                finalPage.classList.add('active');
                progressSection.classList.remove('hidden');
                break;
            default: // Question Pages
                const questionPageIndex = stepIndex - 3; // 0-based question index
                const pageToShow = document.getElementById(`question-page-${questionPageIndex + 1}`);
                if (pageToShow) {
                    pageToShow.classList.add('active');
                    progressSection.classList.remove('hidden');
                    currentCategoryTitleDiv.classList.remove('hidden');
                    
                    // Update category title
                    const currentQuestion = questionsData[questionPageIndex];
                    if (currentQuestion) {
                        currentCategoryTitleH3.textContent = currentQuestion.category;
                    }
                }
                break;
        }
        updateNavigationButtons();
        updateProgressBar();
    }

    // Update navigation buttons state
    function updateNavigationButtons() {
        const isWelcomePage = currentStepIndex === 0;
        const isFinalPage = currentStepIndex === totalSteps - 1;
        const isRespondentDataPage = currentStepIndex === 1;
        const isInstructionsPage = currentStepIndex === 2;
        const isFirstQuestion = currentStepIndex === 3;
        const isLastQuestion = currentStepIndex === 3 + totalQuestions - 1;

        prevButton.classList.toggle('hidden', isWelcomePage);
        
        if (isWelcomePage) {
            nextButton.classList.add('hidden');
            startSurveyButton.classList.remove('hidden');
        } else {
            startSurveyButton.classList.add('hidden');
            nextButton.classList.remove('hidden');
            if (isFinalPage) {
                nextButton.classList.add('hidden');
                submitButton.style.display = 'flex';
            } else {
                nextButton.classList.remove('hidden');
                submitButton.style.display = 'none';
                if (isInstructionsPage) {
                    nextButton.innerHTML = '<i class="fas fa-arrow-right"></i> Mulai Pertanyaan';
                } else if (isRespondentDataPage) {
                    nextButton.innerHTML = '<i class="fas fa-arrow-right"></i> Lanjut ke Petunjuk';
                } else if (isLastQuestion) {
                    nextButton.innerHTML = '<i class="fas fa-arrow-right"></i> Ke Halaman Akhir';
                } else {
                    nextButton.innerHTML = '<i class="fas fa-arrow-right"></i> Selanjutnya';
                }
            }
        }
    }

    // Update progress bar
    function updateProgressBar() {
        let answeredQuestions = 0;
        for (let i = 1; i <= totalQuestions; i++) {
            const answer = document.querySelector(`input[name="q${i}"]:checked`);
            if (answer) answeredQuestions++;
        }
        
        let progressPercentage = 0;
        const stepsBeforeQuestions = 3; // Welcome, Data, Instructions
        const questionsStepProgress = answeredQuestions / totalQuestions;
        
        if (currentStepIndex < stepsBeforeQuestions) {
            progressPercentage = Math.round((currentStepIndex / (totalSteps - 1)) * 100);
        } else if (currentStepIndex === totalSteps - 1) { // On final page
             progressPercentage = Math.round((answeredQuestions / totalQuestions) * 100);
        } else { // During questions
            const currentQuestionStep = currentStepIndex - stepsBeforeQuestions;
            const overallProgress = (stepsBeforeQuestions + currentQuestionStep + questionsStepProgress) / (totalSteps -1);
            progressPercentage = Math.round(overallProgress * 100);
        }

        progressBarFill.style.width = `${progressPercentage}%`;
        progressText.textContent = `${progressPercentage}% Selesai`;
    }

    // Validate current question before moving to next
    function validateCurrentQuestion() {
        // Validate respondent data fields
        if (currentStepIndex === 1) {
            const studentClass = document.getElementById('studentClass').value.trim();
            const teacherName = document.getElementById('teacherName').value.trim();
            
            if (!studentClass) {
                alert('Mohon isi field Kelas sebelum melanjutkan.');
                document.getElementById('studentClass').focus();
                return false;
            }
            
            if (!teacherName) {
                alert('Mohon isi field Nama Guru yang Dinilai sebelum melanjutkan.');
                document.getElementById('teacherName').focus();
                return false;
            }
        }
        
        // Validate question answers
        if (currentStepIndex >= 3 && currentStepIndex < 3 + totalQuestions) {
            const questionPageIndex = currentStepIndex - 3;
            const answer = document.querySelector(`input[name="q${questionPageIndex + 1}"]:checked`);
            if (!answer) {
                alert('Mohon jawab pertanyaan ini sebelum melanjutkan.');
                return false;
            }
        }
        return true;
    }

    // Event Listeners
    startSurveyButton.addEventListener('click', () => {
        showStep(1);
    });

    prevButton.addEventListener('click', () => {
        if (currentStepIndex > 0) {
            showStep(currentStepIndex - 1);
        }
    });

    nextButton.addEventListener('click', () => {
        if (currentStepIndex < totalSteps - 1) {
            if (validateCurrentQuestion()) {
                showStep(currentStepIndex + 1);
            }
        }
    });

    // Form submission
    form.addEventListener('submit', async function(event) {
        event.preventDefault();

        // Final validation: check all questions and required fields
        let allAnswered = true;
        let firstUnansweredIndex = -1;
        document.querySelectorAll('.question-page').forEach(page => { // Remove previous error styles if any
            page.style.borderColor = ''; // Reset border
        });

        // Check if all questions are answered
        for (let i = 0; i < totalQuestions; i++) {
            const answer = document.querySelector(`input[name="q${i + 1}"]:checked`);
            if (!answer) {
                allAnswered = false;
                if (firstUnansweredIndex === -1) {
                    firstUnansweredIndex = i;
                }
            }
        }

        if (!allAnswered) {
            alert('Mohon jawab semua pertanyaan sebelum mengirim.');
            if (firstUnansweredIndex !== -1) {
                showStep(3 + firstUnansweredIndex); // Go to the first unanswered question
                // Optionally, add a visual cue like a red border
                const unansweredPage = document.getElementById(`question-page-${firstUnansweredIndex + 1}`);
                if(unansweredPage) {
                    unansweredPage.style.borderColor = 'var(--danger-text-color)';
                    unansweredPage.style.borderWidth = '3px';
                }
            }
            return;
        }

        // Check if required text fields are filled
        const feedback = document.getElementById('feedback').value.trim();
        const parentSupport = document.getElementById('parentSupport').value.trim();

        if (!feedback) {
            alert('Mohon isi field Saran dan Masukan sebelum mengirim.');
            showStep(3 + totalQuestions); // Go to final page
            document.getElementById('feedback').focus();
            return;
        }

        if (!parentSupport) {
            alert('Mohon isi field Dukungan yang bisa diberikan sebelum mengirim.');
            showStep(3 + totalQuestions); // Go to final page
            document.getElementById('parentSupport').focus();
            return;
        }

        // Collect form data
        const formData = new FormData(form);
        const respondentData = {
            studentName: formData.get('studentName') || null,
            parentName: formData.get('parentName') || null,
            studentClass: formData.get('studentClass') || null,
            teacherName: formData.get('teacherName') || null,
            feedback: formData.get('feedback') || null,
            parentSupport: formData.get('parentSupport') || null,
        };

        const answers = {};
        for (let i = 1; i <= totalQuestions; i++) {
            const answerInput = document.querySelector(`input[name="q${i}"]:checked`);
            answers[`q${i}`] = answerInput ? parseInt(answerInput.value) : null;
        }
        
        // Prepare data for insertion
        let dataToInsert = {
            ...answers,
            submitted_at: new Date().toISOString(),
        };

        // Add respondent data only if they have values
        if (respondentData.studentName) dataToInsert.studentName = respondentData.studentName;
        if (respondentData.parentName) dataToInsert.parentName = respondentData.parentName;
        if (respondentData.studentClass) dataToInsert.studentClass = respondentData.studentClass;
        if (respondentData.teacherName) dataToInsert.teacherName = respondentData.teacherName;
        if (respondentData.feedback) dataToInsert.feedback = respondentData.feedback;
        if (respondentData.parentSupport) dataToInsert.parentSupport = respondentData.parentSupport;

        // Show loading state on button
        const originalButtonContent = submitButton.innerHTML;
        submitButton.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Mengirim...';
        submitButton.disabled = true;

        // Try to send data to Supabase
        let { data, error } = await supabase
            .from('survey_responses')
            .insert([dataToInsert]);

        // If error occurs, try without the problematic columns (fallback mechanism)
        if (error && error.message && error.message.includes('column') && error.message.includes('does not exist')) {
            console.warn('Some columns not found in database, trying fallback with basic columns only...');
            
            // Extract the column name from error message
            const columnNameMatch = error.message.match(/column "([^"]+)" of relation "survey_responses" does not exist/);
            const problematicColumn = columnNameMatch ? columnNameMatch[1] : null;
            
            if (problematicColumn) {
                console.warn(`Problematic column identified: ${problematicColumn}`);
            }
            
            // Create basic fallback data with only essential columns
            const basicFallbackData = {
                ...answers,
                submitted_at: new Date().toISOString(),
            };
            
            // Try with only the basic data first
            const basicResult = await supabase
                .from('survey_responses')
                .insert([basicFallbackData]);
            
            if (basicResult.error) {
                // If even basic data fails, we have a serious database issue
                data = basicResult.data;
                error = basicResult.error;
            } else {
                // Basic data succeeded, now try to add respondent data columns one by one
                let finalData = { ...basicFallbackData };
                const respondentFields = [
                    { key: 'studentName', value: respondentData.studentName },
                    { key: 'studentClass', value: respondentData.studentClass },
                    { key: 'teacherName', value: respondentData.teacherName },
                    { key: 'feedback', value: respondentData.feedback },
                    { key: 'parentSupport', value: respondentData.parentSupport },
                    { key: 'parentName', value: respondentData.parentName }
                ];
                
                // Try to update with each field separately to identify which ones work
                for (const field of respondentFields) {
                    if (field.value) {
                        try {
                            const updateData = { [field.key]: field.value };
                            const updateResult = await supabase
                                .from('survey_responses')
                                .update(updateData)
                                .eq('id', basicResult.data[0].id);
                            
                            if (!updateResult.error) {
                                finalData[field.key] = field.value;
                                console.log(`Successfully added field: ${field.key}`);
                            } else {
                                console.warn(`Failed to add field: ${field.key}`);
                            }
                        } catch (err) {
                            console.warn(`Error adding field ${field.key}:`, err);
                        }
                    }
                }
                
                data = [finalData];
                error = null;
            }
        }

        // Reset button state
        submitButton.innerHTML = originalButtonContent;
        submitButton.disabled = false;

        if (error) {
            console.error('Error inserting data:', error);
            
            // Check if the error is related to missing columns
            if (error.message && error.message.includes('column') && error.message.includes('does not exist')) {
                alert('Terdapat kesalahan pada struktur database. Kolom yang diperlukan belum tersedia. Silakan hubungi administrator untuk menjalankan update database.');
            } else if (error.code === '23505') {
                alert('Data sudah pernah dikirim sebelumnya.');
            } else if (error.code === '23502') {
                alert('Data wajib tidak lengkap. Silakan periksa kembali isian Anda.');
            } else {
                alert('Gagal mengirim jawaban. Error: ' + (error.message || 'Unknown error') + '. Silakan coba lagi nanti.');
            }
        } else {
            console.log('Data inserted successfully:', data);
            form.style.display = 'none'; // Hide the entire form
            thankYouMessage.classList.remove('hidden');
            window.scrollTo(0, 0);
        }
    });

    // Initialize the survey
    initializeQuestionPages();
    showStep(0); // Start with the welcome page
});
